import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import { formatAcres } from "../../utils/acreageFormatting.js";

function TableRow({ row }) {
  const navigate = useNavigate();
  return (
    <div className="grid grid-cols-10 text-sm  text-[#666]  hover:bg-[#f9f9f9] font-medium gap-4 border-b-[1px] border-[#DDD]">
      <div className="col-span-1 underline py-1 px-3 h-[45px] flex items-center">
        {
          <Tooltip title="Edit Field">
            <IconButton
              onClick={() =>
                navigate(`/farm/${row.farm_id}/field/${row.id}/form`)
              }
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        }
      </div>
      <div className="col-span-2 underline py-1 px-3 h-[45px] flex items-center">
        {
          <Link to={`/farm/${row.farm_id}/field/${row.id}`}>
            {row.name}
          </Link>
        }
      </div>
      <div className="col-span-1 py-1 px-3 h-[45px] flex items-center">
        {formatAcres(row.field_size, "Not set")}
      </div>
      <div className="col-span-2 py-1 px-3 h-[45px] flex items-center">
        {row.field_address}
      </div>
      <div className="col-span-1 py-1 px-3 h-[45px] flex items-center">
        {row.tillage_regime}
      </div>
      <div className="col-span-1 py-1 px-3 h-[45px] flex items-center">
        {row.previous_tillage_regime}
      </div>
      <div className="col-span-2 py-1 px-3 h-[45px] flex items-center">
        {Number.isInteger(row.regime_change_date)
          ? row.regime_change_date
          : row.regime_change_date?.slice(0, 10)}
      </div>
    </div>
  );
}

export default function ManagedAcresTable({ fields, isLoading }) {
  const noDataDefaultRow =
    isLoading === false && fields.length === 0 ? (
      <p className="my-4">
        There are no fields in this farm yet. Please add a field with the
        controls above.{" "}
      </p>
    ) : null;

  return (
    <div
      style={{ border: "0.5px solid #DDD" }}
      className="overflow-hidden rounded-md shadow-md mb-4 min-w-[830px]"
    >
      {/*  Header */}
      <div className="grid grid-cols-10 text-xs bg-[#EBEBEB] text-[#333] font-bold gap-4">
        <div className="col-span-1 py-1 px-3 h-10 flex items-center">
          Actions
        </div>

        <div className="col-span-2 py-1 px-3 h-10 flex items-center">Field</div>
        <div className="col-span-1 py-1 px-3 h-10 flex items-center">Acres</div>
        <div className="col-span-2 py-2 px-3 h-10 flex items-center">
          Address
        </div>
        <div className="col-span-1 py-1 px-3 h-10 flex items-center">
          Tillage
        </div>
        <div className="col-span-1 py-1 px-3 h-10 flex items-center">
          Previous Regime
        </div>
        <div className="col-span-2 py-1 px-3 h-10 flex items-center">
          Change Date
        </div>
      </div>
      {isLoading && <LinearProgress />}
      {/* Body */}
      <ul className="w-full">
        {fields.map((row) => {
          if (typeof row === "object") console.log(row, "EL REAL");
          return (
            <li className="w-full" key={row.id}>
              <TableRow row={row} />
            </li>
          );
        })}
        <li className="w-full text-center">{noDataDefaultRow}</li>
      </ul>
    </div>
  );
}
